export const feng = 'http://192.168.0.13:8069';
export const frank = 'http://192.168.0.126:8069';
export const annt= 'http://10.148.0.4:8070';
export const dev = (location.origin || location.protocol + '//' + location.host);
// export const url = 'http://192.168.0.126:8079';
export const url = '';
